import { useState, useEffect } from "react";
import { Label } from "../ui/label";
import AutogrowTextarea from "../ui/autogrowtextarea";

const TextArea = ({ itemkey, content, onChange, defaultValue }) => {
  const [value, setValue] = useState("");

  const handleValueChange = (e) => {
    if (onChange) {
      setValue(e.target.value);
      onChange(content.key, e.target.value);
    } else {
      setValue(defaultValue || "");
    }
  };

  useEffect(() => {
    setValue(defaultValue || "");
  }, [defaultValue]);

  return (
    <div className="mt-3 text-start">
      <Label className="font-semibold text-gray-800 text-sm mb-1.5 block">
        {content.label}
      </Label>
      <AutogrowTextarea
        minHeight={80}
        value={value}
        onChange={handleValueChange}
        placeholder={content.placeholder || "Type your answer here..."}
      />
    </div>
  );
};

export default TextArea;
